// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"e723b95c","239":"f25e507f","453":"9a939b43","977":"84af7d3a"}[chunkId] + ".chunk.js";
};